import React from "react";
import Hero from "../Components/Hero/Hero";
import Popular from "../Components/Popular/Popular";
import Offers from "../Components/Offers/Offers";
import NewCollection from "../Components/NewCollection/NewCollection";
import Newsletter from "../Components/NewsLetter/Newsletter";

const Shop = () => {
  return (
    <div>
      <Hero></Hero>
      <Popular />
      <Offers />
      <NewCollection />
      <Newsletter />
    </div>
  );
};

export default Shop;
